module.exports = __webpack_public_path__ + "img/webm.ac622edf.svg";